






























import Element from 'element-ui'
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import {
  UnitBuiltProjectData,
  emptyProject
} from '@/api/heritageUnit/unitProtectPlan'
import { validateIntKey, validateLngLat, showVaildMsg } from '@/configs/validate'
import { OfficialDocData } from '@/api/officialDoc/doc'
import DocSelector from '@/components/officialDoc/select.vue'
import FormDialog from '@/components/dialog/formDialog.vue'

const getFormRules = (form: { [key: string]: string }) => {
  return {
    // DocId: [
    //   { required: true, message: '请输入所建项目', trigger: 'blur' }
    // ],
    Specification: [
      { required: true, message: '请输入所建项目', trigger: 'blur' }
    ]
  }
}
@Component({
  components: { FormDialog, DocSelector }
})
export default class UnitBuiltProjectForm extends Vue {
  public name = 'UnitBuiltProjectForm'
  // 关闭窗口，在 dialog 的 :before-close属性中触发，然后调用父级中的方法
  @Prop({ default: null })
  public closeDialog!: () => void
  public showDialog: boolean = false

  public loading: boolean = true
  public form: UnitBuiltProjectData = Object.assign({}, emptyProject)
  public rules = getFormRules(this.form)
  public $refs!: {
    formData: Element.Form
  }
  public getUnitBuiltProjectDoc(info: { data: OfficialDocData; refTo: string }) {
    console.log(info)
    const data = info.data
    this.form.DocId = data.Id
    this.form.DocNo = data.DocCompileNo
  }
  public created() { }
  public mounted() {
    window.eventBus.$on(
      'openUnitBuiltProjectForm',
      (data: UnitBuiltProjectData) => {
        this.loading = true
        this.open()
        this.form = Object.assign({}, data)
        this.loading = false
      }
    )
  }
  public beforeDestroy() {
    window.eventBus.$off('openUnitBuiltProjectForm')
  }
  public open() {
    this.showDialog = true
  }
  public close() {
    this.loading = true
    this.showDialog = false
    this.$refs.formData.resetFields()
    if (this.closeDialog) {
      this.closeDialog()
    }
  }
  public sendData(data: UnitBuiltProjectData) {
    console.log('submitUnitBuiltProjectForm', data)
    window.eventBus.$emit('submitUnitBuiltProjectForm', data)
  }
  public onSubmit() {
    const f = Object.assign({}, this.form)
    if (f.DocId == 0) {
      this.$message({
        type: 'warning',
        message: '请选择批文'
      })
      return false
    }
    this.$refs.formData.validate((valid: boolean, obj: any) => {
      if (valid) {
        this.sendData(f)
        this.close()
      } else {
        showVaildMsg(this.$message, obj)
      }
    })
  }
}
